<script setup lang="ts">
import type { ItemType } from '~~/src/types/api'

const filters = useFilters()

const itemTypes: ItemType[] = ['all', 'prompt', 'list']
const selectedItemType = computed({
  get: () => filters.value.item_type || 'all',
  set: (value: ItemType) => changeItemType(value),
})

const itemTypeLabels: Record<ItemType, string> = {
  all: 'Items/Lists',
  prompt: 'Items',
  list: 'Lists',
}

watch(filters, () => {
  if (selectedItemType.value !== filters.value.item_type)
    selectedItemType.value = filters.value.item_type || 'all'
})

function changeItemType(itemType: ItemType) {
  if (itemType !== filters.value.item_type) {
    filters.value = {
      ...filters.value,
      item_type: itemType,
    }

    selectedItemType.value = itemType
  }
}
</script>

<script lang="ts">
export default defineComponent({
  name: 'FilterItemType',
})
</script>

<template>
  <PopupMenu>
    <template #default="{ isShown }">
      <AppButton variant="clear" relative pl-0 pr-0 class="!text-soft-black">
        <div flex items-center whitespace-nowrap class="gap-[2px] md:gap-1">
          <span class="text-[12px] md:text-[14px]">{{ itemTypeLabels[selectedItemType] }}</span>
          <div
            i-mdi:chevron-down text-lg duration-125 transform
            :class="isShown ? '-rotate-180' : 'rotate-0'"
          />
        </div>
      </AppButton>
    </template>

    <template #content>
      <AppFloatingMenu>
        <ul flex>
          <AppFloatingMenuItem v-for="itemType in itemTypes" :key="itemType" @click="changeItemType(itemType)">
            <Text>{{ itemTypeLabels[itemType] }}</Text>
          </AppFloatingMenuItem>
        </ul>
      </AppFloatingMenu>
    </template>
  </PopupMenu>
</template>
